import request from '@/utils/request';

const requestInstance = request();

/**
 * 获取当前登录用户app列表
 * @returns {*}
 */
export function listAppByPageInCurrentUser(parameter) {
  return requestInstance.post('/api/appInfo/listByPageInCurrentUser', parameter);
}

/**
 * 获取app
 * @returns {*}
 */
export function getApp(parameter) {
  return requestInstance.post('/api/appInfo/get', parameter);
}

/**
 * 创建app
 * @returns {*}
 */
export function createApp(parameter) {
  return requestInstance.post('/api/appInfo/create', parameter);
}

/**
 * 修改app
 * @returns {*}
 */
export function updateApp(parameter) {
  return requestInstance.post('/api/appInfo/update', parameter);
}

/**
 * 删除app
 * @returns {*}
 */
export function deleteApp(parameter) {
  return requestInstance.post('/api/appInfo/delete', parameter);
}


/**
 * 获取绑定列表
 * @returns {*}
 */
export function listBindByPage(parameter) {
  return requestInstance.post('/api/userRelation/listByPage', parameter);
}

/**
 * 删除绑定
 * @returns {*}
 */
export function deleteRelation(parameter) {
  return requestInstance.post('/api/userRelation/delete', parameter);
}

/**
 * 删除app
 * @returns {*}
 */
export function applyResetAppKey(parameter) {
  return requestInstance.post('/api/appInfo/applyResetAppKey', parameter);
}

/**
 * 删除绑定
 * @returns {*}
 */
export function deleteRelationBatch(parameter) {
  return requestInstance.post('/api/userRelation/deleteBatch', parameter);
}
